import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HpaSharedServiceService {

  constructor() { }
  private specificationSubject = new Subject<any>();
  public specification$ = this.specificationSubject.asObservable();
  private sizeSubject = new Subject<any>();
  public size$ = this.sizeSubject.asObservable();
  private productSpecificationSubject = new Subject<any>();
  public productSpecification$ = this.productSpecificationSubject.asObservable();
  
  private finalSpecificationSubject = new Subject<any>();
  public finalSpecification$ = this.finalSpecificationSubject.asObservable();
  private cadSubject = new Subject<any>();
  public cad$ = this.cadSubject.asObservable();
  setSpecification(data: any): void {
    this.specificationSubject.next(data); // Emit new data to subscribers
  }
  private formDataSubject = new BehaviorSubject<any>({
    selectedInputPower: null,
    selectedUnits: null,
    selectedRatio: null,
    selectedSpeed: null,
    selectedDutyCycle: null,
    selectedServiceFactor: null,
    selectedOutputSpeed: null
  });
  formData$ = this.formDataSubject.asObservable();

  setFormData(data: any): void {
    this.formDataSubject.next(data);
  }

  getFormData() {
    return this.formDataSubject.asObservable();
  }
  setSize(data:any):void{
    this.sizeSubject.next(data);
  }
  setProductSpecification(data: any): void {
    this.productSpecificationSubject.next(data); // Emit new data to subscribers
  }
  setFinalSpecification(data: any): void {
    this.finalSpecificationSubject.next(data); // Emit new data to subscribers
  }
  setCadData(data: any): void {
    this.cadSubject.next(data); // Emit new data to subscribers
  }
  private SeriesSubject = new BehaviorSubject<any>({
    series: null
  });
  seriesData$ = this.SeriesSubject.asObservable();

setSeriesData(data: any): void {
  this.SeriesSubject.next(data);
}

getSeriesData() {
  return this.SeriesSubject.asObservable();
}

private productCodeSubject = new Subject<any>();
  public productCode$ = this.productCodeSubject.asObservable();
setProductCode(data: any): void {
  this.productCodeSubject.next(data); // Emit new data to subscribers
}
}
